import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';

export default class EPolyline extends OBase {
  update () {
    let pointsTree1 = this.getVector3Input('Vertices', false);
    let pointsTree2 = this.getVector3Input('Vertices', false);
    let closeTree = this.getBoolInput('Closed');

    let output = this.outputs['Polyline'].paramObject;

    let dataTrees = [pointsTree1, pointsTree2, closeTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      let closed = outDataTrees[2].branches[i][0];

      if (closed) {
        let paths = EPolyline.createPolyline(outDataTrees[0].branches[i]);
        outTree.add(paths, outDataTrees[0].paths[i]);
      } else {
        let path = outDataTrees[1].branches[i].map(p => new ClipperLib.DoublePoint(p.x, p.y));
        outTree.add([path], outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }

  static removeDuplicatePoints (points, thresh) {
    let removedPoints = [];
    for (let i = 0; i < points.length; i++) {
      let pt1 = points[i];
      let ignore = false;
      for (let j = i + 1; j < points.length; j++) {
        let pt2 = points[j];
        if (pt1.distanceTo(pt2) < thresh) {
          ignore = true;
          break;
        }
      }
      if (ignore === false) {
        removedPoints.push(pt1);
      }
    }
    return removedPoints;
  }

  static createPolyline (points) {
    let path = [];
    for (let j = 0; j < points.length; j++) {
      let point = points[j];
      path.push(new ClipperLib.DoublePoint(point.x, point.y));
    }

    path.reverse();
    if (GHMath.isClockwise(path)) {
      path.reverse();
    }

    return [path];
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EPolyline.js